var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBottomLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M2.4 8.031v12.737c0 .459.373.832.832.832H15.97a.832.832 0 0 0 0-1.664H4.064V8.031a.832.832 0 0 0-1.664 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "m10.518 14.753 9.169-9.168a.9.9 0 1 0-1.273-1.273L9.245 13.48l-1.909-1.909.007 5.085 5.085.006z"
})));
export default SvgBottomLeft;